import { Link } from "react-router-dom";

export default function ComingSoon() {
  return (
    
    <div className="coming-soon-page">
      <section className="text-area">
        <h1>Coming Soon!</h1>
          <div className="coldflare-links">
            <Link className="page-button" to='/arcade'>
              <p>Back To Arcade</p>
            </Link>
          </div>
      </section> 

    </div>
  );
}

